// storage service
import { getPersistentItem, removePersistentItem, setPersistentItem } from './utils/storage';

export const persistentStorage = {
  get: getPersistentItem,
  set: setPersistentItem,
  remove: removePersistentItem,
};

export function overridePersistentStorage(s) {
  if (s && s.get) {
    persistentStorage.get = s.get;
  }

  if (s && s.set) {
    persistentStorage.set = s.set;
  }
}
